/**
 * Portail state router
 * @param $stateProvider
 */
function stateRouter($stateProvider) {
    $stateProvider.state('nap', {
        data: {
            title: 'Espace Nap'
        },
        url         : '/portail/nap',
        template    : require('./partials/nap.html'),
        controller  : 'NapCtrl',
        controllerAs: 'napCtrl',
        resolve     : {
            categories: function (napService, authService) {
                return napService.fetchCategories(authService.getAuthInfos());
            }
        }
    });
}

angular.module('app.portail.nap', []).config(stateRouter);

require('./controllers/napCtrl');
require('./services/napService');
